<div class="row">
  <div [class]="'col-12 ' + customOptions?.ratingAlignClass">
    <ngb-rating [rate]="value"
      id="custom-ngb-rating"
      class="ngb-rating text-warning text-warning"
      (rateChange)="notifyValue($event)"
      [max]="data?.ratingScale || 5"
      [readonly]="viewOnly"
      required></ngb-rating>
  </div>
</div>
